 const toggleButton = document.querySelector('.collection-listing__sortings-toggle');
  const closeButton = document.querySelector('.collection-listing__sortings-filtering-close-btn');
  const overlay = document.querySelector('.collection-listing__sortings-filtering');
  const mobileNavBtn = document.querySelector('.header__mob-menu-trigger');
  const mobileNavCloseBtn = document.querySelector('.header__mob-menu-close-btn');
  const mobileNavOverlay = document.querySelector('.header__mob-menu');

  if (toggleButton) {
    toggleButton.addEventListener('click', function () {

      setTimeout(function () {
        const zigpollContainer = document.getElementById('zigpoll-container');
        if (zigpollContainer) {
          zigpollContainer.style.display = "none";
        }
      }, 500); // Delay in milliseconds
    });
  }

  if(mobileNavBtn) {
	mobileNavBtn.addEventListener('click', function () {
  
		setTimeout(function () {
		  const zigpollContainer = document.getElementById('zigpoll-container');
		  if (zigpollContainer) {
			zigpollContainer.style.display = "none";
		  }
		}, 500); // Delay in milliseconds
	  });
  }

  function showZigpoll() {
    const zigpollContainer = document.getElementById('zigpoll-container');
    if (zigpollContainer) {
      zigpollContainer.style.display = "block";
    }
  }

  if (closeButton) {
    closeButton.addEventListener('click', showZigpoll);
  }

  if(mobileNavCloseBtn) {
	mobileNavCloseBtn.addEventListener('click', showZigpoll);
  }

  if (overlay) {
    overlay.addEventListener('click', showZigpoll);
  }

  if(mobileNavOverlay) {
	mobileNavOverlay.addEventListener('click', showZigpoll);
  }